class ConfigurationManager {
    static AMB = "PRODUCTION"; // Puedes cambiar esto a process.env.NODE_ENV si es necesario

    // Common configurations
    static RECAPTCHA_PUBLIC_KEY = "6LfN17UcAAAAAIwXSBsoC5nsngHXPxsyti24MQcT";
    static VERSION = "v26.0.0";

    // Environment-specific configurations
    static environments = {
        DEVELOPMENT: {
            API_URL: "https://localhost:44319",
            RED_URL: "https://localhost:44319/eld"
        },
        QA: {
            API_URL: "https://turetiroconmodeloback-qa.afpmodelo.net",
            RED_URL: "https://turetiroconmodelo-qa.afpmodelo.net/eld"
        },
        PRODUCTION: {
            API_URL: "https://turetiroconmodeloback.afpmodelo.net",
            RED_URL: "https://turetiroconmodelo.cl/eld"
        }
    };

    // Dynamic values based on the current environment
    static API_URL = "";
    static RED_URL = "";
    static JSON_HEADER = null;

    static setApiUrls() {
        const env = this.environments[this.AMB];

        if (env) {
            this.API_URL = env.API_URL;
            this.RED_URL = env.RED_URL;
            this.JSON_HEADER = { "Content-Type": "application/json" };
        }
    }

    static getApiUrl() {
        return this.API_URL;
    }

    static getRedUrl() {
        return this.RED_URL;
    }

    static getJsonHeader() {
        return this.JSON_HEADER;
    }

    static getAmb() {
        return this.AMB;
    }

    static getRecaptcha() {
        return this.RECAPTCHA_PUBLIC_KEY;
    }

    static getVersion() {
        return this.VERSION;
    }
}

// Example usage:
ConfigurationManager.setApiUrls();

export default ConfigurationManager;
